import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import InvoiceGrid from '../../components/grids/Invoicing/InvoiceGrid'
import { getInvoices, exportInvoice } from '../../data/invoiceData'
import { invoiceGrid } from '../../data/interfaces'

interface InvoicingProps {
 lockEdit: boolean
}

/**
 * The Sales list. Creating or opening an invoice goes to its own page
 * (/invoicing/new, /invoicing/:invoiceId), where its details and lines are
 * edited together.
 */
const Invoicing = (props: InvoicingProps) => {
   const navigate = useNavigate()
   const [invoiceData, setInvoiceData] = useState<invoiceGrid[]>([])
   const [monthCreatedBy, setMonthCreatedBy] = useState<number | null>(null)

   // Old links to an invoice (/invoicing?id=123) now open its page.
   const [searchParams] = useSearchParams();
   useEffect(() => {
      const id = searchParams.getAll("id")[0];
      if (id) {
         navigate(`/invoicing/${id}`, { replace: true })
      }
   }, [searchParams, navigate])

   useEffect(() => {
      const fetchData = async () => {
         const invoiceData = await getInvoices(monthCreatedBy)
         setInvoiceData(invoiceData)
      }
      fetchData();
   }, [monthCreatedBy])

   return (
      <div>
         <InvoiceGrid
            lockEdit={props.lockEdit}
            onAddToggle={() => navigate('/invoicing/new')}
            onEditToggle={(id: number) => navigate(`/invoicing/${id}`)}
            onData={invoiceData}
            onInvoiceExport={(id: number, ref: string) => exportInvoice(id, ref)}
            onMonthCreatedBy={(value: number) => setMonthCreatedBy(value)}
         />
      </div>
   );
}

export default Invoicing;
